<template>
  <div
    v-if="candidate"
    v-bind:class="hidediv ? 'dis' : ''"
    :id="candidate.CandidateIdentifier.Id"
    class="candidate"
  >
    <md-card
      elevation="15"
      style="max-width:100%;"
      v-bind:class="{ voted: voted }"
    >
      <md-card-header class="md-layout bold" style="align-items: center;">
        <div
          class="md-layout-item md-size-70"
          @click="isMobile ? selectCandidateCardAndVote() : ''"
        >
          <span>
            {{ candidate.CandidateIdentifier.CandidateName }}
            <span
              class="md-caption"
              v-if="candidate.CandidateIdentifier.KnownAs"
              ><br />
              {{ candidate.CandidateIdentifier.KnownAs }}
            </span>
          </span>
        </div>
        <div class="md-layout-item md-size-15">
          <!-- &&
                candidate.Profile.Message.content &&
                candidate.Profile.Message.content.Fields &&
                candidate.Profile.Message.content.Fields.length > 0 -->
          <md-button
            v-if="candidate.Profile"
            class="md-icon-button md-dark"
            @click="info = true"
            :id="'info-' + candidate.CandidateIdentifier.Id"
            ><span class="screenreader"
              >{{ $t("candidate.info-candidate-button") }}
              {{ candidate.CandidateIdentifier.CandidateName }},
              <span
                v-if="candidate.CandidateIdentifier.KnownAs"
                class="screenreader"
              >
                {{ candidate.CandidateIdentifier.KnownAs }}
              </span></span
            >
            <md-icon class="md-size-1x" aria-hidden="true" role="presentation"
              >info_outline</md-icon
            >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              >{{ $t("candidate.info-candidate-button") }}</md-tooltip
            >
          </md-button>
        </div>
        <div class="md-layout-item md-size-15">
          <md-button
            :id="'vote-' + candidate.CandidateIdentifier.Id"
            class="md-icon-button md-primary"
            @click="vote()"
            :disabled="!this.voted && (disabled || checkDisabled)"
            :aria-disabled="
              (!this.voted && (disabled || checkDisabled)) ||
                (sexVoted != 0 && !voted && checkDisabled) ||
                (sexVoted == 0 && !voted && disabled)
            "
            ref="voteButton"
          >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              >{{ $t("candidate.select-candidate-button") }}</md-tooltip
            >
            <md-icon
              class="md-size-2x"
              v-if="voted"
              aria-hidden="true"
              role="presentation"
              >check_circle</md-icon
            ><span v-if="voted" class="screenreader"
              >{{ $t("candidate.selected-candidate-button") }}
              {{ candidate.CandidateIdentifier.CandidateName }},
              <span
                v-if="candidate.CandidateIdentifier.KnownAs"
                class="screenreader"
              >
                {{ candidate.CandidateIdentifier.KnownAs }}</span
              ></span
            >
            <md-icon
              class="md-size-1x"
              v-if="
                (sexVoted != 0 && !voted && !checkDisabled) ||
                  (sexVoted == 0 && !voted && !disabled)
              "
              aria-hidden="true"
              role="presentation"
              >check_circle_outline</md-icon
            ><span
              v-if="
                (sexVoted != 0 && !voted && !checkDisabled) ||
                  (sexVoted == 0 && !voted && !disabled)
              "
              class="screenreader"
              >{{ $t("candidate.select-candidate-button") }}
              {{ candidate.CandidateIdentifier.CandidateName }},
              <span
                v-if="candidate.CandidateIdentifier.KnownAs"
                class="screenreader"
              >
                {{ candidate.CandidateIdentifier.KnownAs }}</span
              ></span
            >
            <md-icon
              class="md-size-1x"
              v-if="
                (sexVoted != 0 && !voted && checkDisabled) ||
                  (sexVoted == 0 && !voted && disabled)
              "
              aria-hidden="true"
              role="presentation"
              aria-disabled="true"
              >block</md-icon
            ><span
              v-if="
                (sexVoted != 0 && !voted && checkDisabled) ||
                  (sexVoted == 0 && !voted && disabled)
              "
              class="screenreader"
              >{{ $t("candidate.select-candidate-button") }}</span
            >
          </md-button>
        </div>
      </md-card-header>

      <md-dialog
        role="dialog"
        :aria-modal="info"
        id="info"
        :md-fullscreen="false"
        :md-active.sync="info"
        :no-close-on-esc="false"
        :md-click-outside-to-close="false"
        @keydown.tab="
          utils.handleTabNavigation($event, null, null, '#info', null)
        "
        @md-opened="
          hidediv = true;
          $root.$emit('lock');
          !isMobile ? utils.modalOpened('#info') : '';
        "
        @md-closed="
          !isMobile ? utils.removeModalHandler() : '';
          hidediv = false;
          $root.$emit('unlock');
        "
      >
        <md-dialog-content>
          <div class="space">
            <span class="md-title">
              {{ candidate.CandidateIdentifier.CandidateName }}
              <span
                class="md-caption"
                v-if="candidate.CandidateIdentifier.KnownAs"
              >
                ({{ candidate.CandidateIdentifier.KnownAs }})
              </span>
            </span>
          </div>

          <!--<div
            v-if="candidate.DateOfBirth"
            class="md-layout-item md-size-100 label md-caption element custom"
          >
            Data di nascita:
            {{ moment(candidate.DateOfBirth).format("DD/MM/YYYY") }}
          </div>-->
          <!-- <md-list-item v-if="candidate.Gender">
            Genere: {{ candidate.Gender }}
          </md-list-item> -->
          <profileInfo
            :profileInfo="candidate.Profile"
            v-if="candidate.Profile"
          >
          </profileInfo>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button @click="info = false" class="close-button">
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              style="z-index: 20"
              >{{ $t("candidate.info-dialog.close-button") }}</md-tooltip
            >
            {{ $t("candidate.info-dialog.close-button") }}
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </md-card>
  </div>
</template>

<script>
import ProfileInfo from "./ProfileInfo";

import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();
    if (this.previousVoted && process.env.VUE_APP_persistPreference == "true") {
      this.previousVoted.forEach(c => {
        if (
          c.candidate.CandidateIdentifier.Id ==
          this.candidate.CandidateIdentifier.Id
        ) {
          this.$emit("candidateSelected", {
            candidate: this.candidate,
            value: false,
            name: this.candidate.CandidateIdentifier.CandidateName,
            gender: this.candidate.Gender
          });
          this.vote();
        }
      });
    }
    // this.$root.$on("setVoted", id => {
    //   if (
    //     this.candidate.CandidateIdentifier.Id == id.id &&
    //     this.electionId == id.electionId
    //   ) {
    //     this.voted = !this.voted;
    //     console.log("XXXXXXXXX");
    //   }
    // });
  },
  data: function() {
    return {
      info: false,
      voted: false,
      isMobile: null,
      hidediv: false,
      utils: null
    };
  },
  props: ["candidate", "disabled", "sexVoted", "electionId", "previousVoted"],
  methods: {
    vote() {
      this.voted = !this.voted;
      this.$emit("candidateSelected", {
        candidate: this.candidate,
        value: this.voted,
        name: this.candidate.CandidateIdentifier.CandidateName,
        gender: this.candidate.Gender
      });
    },
    selectCandidateCardAndVote() {
      //se e' disabilitato e non votato non si può votare
      if (
        (this.sexVoted != 0 && !this.voted && this.checkDisabled) ||
        (this.sexVoted == 0 && !this.voted && this.disabled)
      )
        return;
      this.vote();
    }
  },
  computed: {
    checkDisabled() {
      // if(sexVoted === 0) return false;
      if (this.sexVoted > 0 && this.candidate.Gender === "male") return true;
      if (this.sexVoted < 0 && this.candidate.Gender === "female") return true;
      else return false;
    }
  },
  components: {
    ProfileInfo
  }
};
</script>
<style scoped>
.md-caption {
  font-size: 14px;
  color: #454545 !important;
}
span.centr {
  display: flow-root;
  text-align: center;
}
span.md-dialog-title {
  background-color: lightgray !important;
  text-align: center !important;
}
.all {
  width: 40% !important;
  height: auto !important;
  max-width: 50%;
  max-height: 100%;
}
.allmobile {
  width: 30% !important;
  height: 40% !important;
  max-width: 90% !important;
  max-height: 100% !important;
  overflow: auto;
}

.allmobile .md-layout {
  flex: 1;
}

.dis {
  pointer-events: none;
}
.md-list.md-theme-default {
  margin: 0 auto;
}

/* .md-button.md-theme-default.md-primary,
.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor);
  color: var(--md-theme-default-primary-on-background, var(--pcolor));
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: var(--pcolor);
  background-color: var(--md-theme-default-primary, var(--pcolor));
} */

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
}

.md-button.md-theme-default[disabled].md-primary .md-icon-font {
  color: rgba(0, 0, 0, 0.8) !important;
}

.mg {
  margin: 10px;
  padding: 10px;
}

.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
  padding-bottom: 20px !important;
  margin: 0 15px;
}

.title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: #fff;
  padding: 0px;
}

.md-dialog-actions {
  margin-bottom: 10px;
}

.md-dialog-content {
  padding: 24px 15px !important;
}

span.md-dialog-title {
  background-color: #fff !important;
  text-align: center !important;
}

.space {
  padding: 10px 0px;
}

.label {
  text-align: left;
  margin: 0px;
  color: #000;
}

.custom {
  margin: 0px;
  padding: 10px 0px 0 0px !important;
  font-size: 16px;
}

.md-caption.bold {
  font-weight: 700;
}

.candidate {
  padding: 0 15px 0 15px;
}

.md-card {
  border-radius: var(--br);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
  border: 1px solid #ccc;
}

.md-button {
  border-radius: var(--brb);
}

.close-button {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
}

.voted {
  /*background-color: #a4dff31f !important;*/
}

.candidate {
  padding: 0;
  margin-bottom: 10px;
}
</style>
